var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_7551)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21053 1.26316H15.7894C16.4871 1.26316 17.0526 1.82874 17.0526 2.52629V3.78942H6.94727V2.52629C6.9474 1.82874 7.51298 1.26316 8.21053 1.26316ZM5.68427 3.78956V2.52642C5.68427 1.13106 6.8153 3.05176e-05 8.21053 3.05176e-05H15.7894C17.1847 3.05176e-05 18.3157 1.13106 18.3157 2.52629V3.78942H22.1052C22.4539 3.78942 22.7368 4.07215 22.7368 4.42099C22.7368 4.76983 22.4539 5.05255 22.1052 5.05255H1.89475C1.54591 5.05255 1.26318 4.76983 1.26318 4.42099C1.26318 4.07215 1.54591 3.78942 1.89475 3.78942H5.68427V3.78956Z",
    fill: "#F42222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21053 1.26316H15.7894C16.4871 1.26316 17.0526 1.82874 17.0526 2.52629V3.78942H6.94727V2.52629C6.9474 1.82874 7.51298 1.26316 8.21053 1.26316ZM5.68427 3.78956V2.52642C5.68427 1.13106 6.8153 3.05176e-05 8.21053 3.05176e-05H15.7894C17.1847 3.05176e-05 18.3157 1.13106 18.3157 2.52629V3.78942H22.1052C22.4539 3.78942 22.7368 4.07215 22.7368 4.42099C22.7368 4.76983 22.4539 5.05255 22.1052 5.05255H1.89475C1.54591 5.05255 1.26318 4.76983 1.26318 4.42099C1.26318 4.07215 1.54591 3.78942 1.89475 3.78942H5.68427V3.78956Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21055 20.8421C7.86171 20.8421 7.57898 20.5592 7.57898 20.2105V10.7369C7.57898 10.3882 7.86171 10.1053 8.21055 10.1053C8.55939 10.1053 8.84212 10.3882 8.84212 10.7369V20.2105C8.84212 20.5592 8.55939 20.8421 8.21055 20.8421Z",
    fill: "#F42222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21055 20.8421C7.86171 20.8421 7.57898 20.5592 7.57898 20.2105V10.7369C7.57898 10.3882 7.86171 10.1053 8.21055 10.1053C8.55939 10.1053 8.84212 10.3882 8.84212 10.7369V20.2105C8.84212 20.5592 8.55939 20.8421 8.21055 20.8421Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 20.8421C11.6514 20.8421 11.3685 20.5592 11.3685 20.2105V10.7369C11.3685 10.3882 11.6514 10.1053 12.0001 10.1053C12.3488 10.1053 12.6317 10.3882 12.6317 10.7369V20.2105C12.6317 20.5592 12.3488 20.8421 12.0001 20.8421Z",
    fill: "#F42222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 20.8421C11.6514 20.8421 11.3685 20.5592 11.3685 20.2105V10.7369C11.3685 10.3882 11.6514 10.1053 12.0001 10.1053C12.3488 10.1053 12.6317 10.3882 12.6317 10.7369V20.2105C12.6317 20.5592 12.3488 20.8421 12.0001 20.8421Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7894 20.8421C15.4407 20.8421 15.1578 20.5592 15.1578 20.2105V10.7369C15.1578 10.3882 15.4407 10.1053 15.7894 10.1053C16.1381 10.1053 16.421 10.3882 16.421 10.7369V20.2105C16.421 20.5592 16.1382 20.8421 15.7894 20.8421Z",
    fill: "#F42222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7894 20.8421C15.4407 20.8421 15.1578 20.5592 15.1578 20.2105V10.7369C15.1578 10.3882 15.4407 10.1053 15.7894 10.1053C16.1381 10.1053 16.421 10.3882 16.421 10.7369V20.2105C16.421 20.5592 16.1382 20.8421 15.7894 20.8421Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.78955 22.7368V7.57894C3.78955 7.2301 4.07227 6.94738 4.42111 6.94738C4.76995 6.94738 5.05268 7.2301 5.05268 7.57894V21.4736C5.05268 22.1713 5.61826 22.7368 6.31581 22.7368H17.6842C18.3819 22.7368 18.9474 22.1713 18.9474 21.4736V7.57894C18.9474 7.2301 19.2302 6.94738 19.5789 6.94738C19.9276 6.94738 20.2105 7.2301 20.2105 7.57894V22.7368C20.2105 23.4345 19.645 23.9999 18.9474 23.9999H5.05268C4.355 24 3.78955 23.4345 3.78955 22.7368Z",
    fill: "#F42222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.78955 22.7368V7.57894C3.78955 7.2301 4.07227 6.94738 4.42111 6.94738C4.76995 6.94738 5.05268 7.2301 5.05268 7.57894V21.4736C5.05268 22.1713 5.61826 22.7368 6.31581 22.7368H17.6842C18.3819 22.7368 18.9474 22.1713 18.9474 21.4736V7.57894C18.9474 7.2301 19.2302 6.94738 19.5789 6.94738C19.9276 6.94738 20.2105 7.2301 20.2105 7.57894V22.7368C20.2105 23.4345 19.645 23.9999 18.9474 23.9999H5.05268C4.355 24 3.78955 23.4345 3.78955 22.7368Z",
    fill: "black",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_7551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.4f57dc8a53968fb31f177bfcc7f7bcb3.svg";
export { ForwardRef as ReactComponent };